import React, { useState, useEffect } from 'react';
import axios from 'axios';
//import { oraPrenotaStore } from "../oraPrenotaStore";
//import { uiStore } from "../uiStore";
import { Button } from "@mui/material";
import { API_URL } from "../consts";
import { SatispayMessaggi } from "./SatispayConsts";

export function SatispayReturn() {
    //const [amount, setAmount] = useState('');
    const [satispayPaymentDetails, setSatispayPaymentDetails] = useState('');
    const [messaggioUlteriore, setMessaggioUlteriore] = useState('');
    const [btnVaiARicarica, setBtnVaiARicarica] = useState(<></>);
    let checkEffettuato = false;

    const verificaDatiPagamento = (oggettoDatiPagamento: Object) => {
        let messaggioConsole = "Verifica stato pagamento con id satispay: ";
        let satispayPaymentId = "";
        const satispayPaymentDetailsLS = localStorage.getItem("satispayPaymentDetails");
        if (satispayPaymentDetailsLS === null) {
            messaggioConsole += "Errore nel reperimento dei dati del pagamento da localStorage";
            console.error(messaggioConsole);
            return false;
        } else {}
        const satispayPaymentDetails = JSON.parse(satispayPaymentDetailsLS);
        //controllo se è presente l'id del pagamento in localStorage
        if (satispayPaymentDetailsLS === null || !('satispayPaymentId' in satispayPaymentDetails) ) {
            messaggioConsole += "Errore nel reperimento dell'id pagamento";
        } else {
            satispayPaymentId = satispayPaymentDetails['satispayPaymentId'].toString();
            messaggioConsole += satispayPaymentId
        }
        console.log(messaggioConsole);
        //return true;
        //Logica per verificare lo stato del pagamento
        if (checkEffettuato) {
            return true;
        } else {}
        axios.post(API_URL + 'ricarica/satispaycheck', { satispay_id: satispayPaymentId })
            .then(response => {
                console.log(response.data);
                const verifySatispayPayment = response.data['verifySatispayPayment'];
                if ('esito' in verifySatispayPayment && verifySatispayPayment['esito'] === 'Ricarica effettuata'){
                    localStorage.removeItem("satispayPaymentDetails");
                    switchStatusDiPagamento("COMPLETED");
                    setSatispayPaymentDetails("Ricarica effettuata con successo");
                }
                return true;
            })
            .catch(error => {
                console.error(error);
                if ( 'message' in error.response.data ) {
                    console.error(error.response.data['message']);
                    //nel caso in cui l'error code sia 404, la ricarica non è stata trovata
                    if (error.response.status === 404) {
                        //rimuovo il pagamento dal localstorage
                        localStorage.removeItem("satispayPaymentDetails");
                        setSatispayPaymentDetails("Non sono stati reperiti dati di pagamento validi");
                        setMessaggioUlteriore(SatispayMessaggi.PAGAMENTONONTROVATO);
                        /*setBtnVaiARicarica(<Button id="vaiARicarica" variant="contained" color="warning" onClick={handleTornaRicaricaForm}>
                            NUOVA RICARICA
                          </Button>);*/
                    }
                }
                return false;
            });
        checkEffettuato = true; //imposto a true il check
        //verifico che l'oggetto non sia nullo
        if (oggettoDatiPagamento === null) {
            console.error("L'oggetto datiPagamento è nullo");
            return false;
        }
        //verifico che contenga le seguenti proprietà
        const prop_da_verificare = ['satispayPaymentId', 'satispaySandBoxMode'];
        for (let i = 0; i < prop_da_verificare.length; i++) {
            try {
                //provo a stampare la proprietà per vedere se esiste
                console.log((oggettoDatiPagamento as any)[prop_da_verificare[i]] as string);
                console.info("L'oggetto datiPagamento contiene la proprietà " + prop_da_verificare[i]);
            } catch (e) {
                console.error("L'oggetto datiPagamento non contiene la proprietà " + prop_da_verificare[i]);
                return false;
            }
            /*if (!oggettoDatiPagamento.hasOwnProperty(prop_da_verificare[i])) {
                console.error("L'oggetto datiPagamento non contiene la proprietà " + prop_da_verificare[i]);
                return false;
            }*/
        }
        return true;
    };

    //let urlPerRedirect = "#";

    useEffect(() => {
        //Leggo i parametri get dalla URL
        const urlParams = new URLSearchParams(window.location.search);
        console.log("urlParams: ", urlParams);
        //leggo la provenienza della chiamata dal referer
        const referer = document.referrer;
        console.log("referer: ", referer);
        //
        const datiRicarica = localStorage.getItem("satispayPaymentDetails");
        if (datiRicarica && datiRicarica !== null) {
            const datiRicaricaObj = JSON.parse(datiRicarica);
            //verifico che datiRicaricaObj sia un oggetto e che contenga le proprietà necessarie
            if ( typeof datiRicaricaObj !== 'object' || !verificaDatiPagamento(datiRicaricaObj)) {
                //console.error("I dati di pagamento non sono validi");
                //return;
                setSatispayPaymentDetails("Non sono stati reperiti dati di avvenuto pagamento validi: "+datiRicarica);
            }
            else if ( datiRicaricaObj.hasOwnProperty('pendingPayments') ) {
                const pendingPayments = datiRicaricaObj['pendingPayments'];
                if (pendingPayments.length > 0) {
                    const pendingPayment = pendingPayments[0];
                    console.log("pendingPayment DA REPORTARE: ", pendingPayment);
                    //setSatispayPaymentDetails("pendingPayment DA REPORTARE: "+JSON.stringify(pendingPayment));
                    //costruisco una istanza dell'interfaccia Riepilogo da dare in pasto a preparaRiepilogoRicarica
                    const riepilogoDaPendingPayment = {
                        amount_unit: pendingPayment.amount_unit,
                        status: pendingPayment.status,
                        id: pendingPayment.satispay_id
                    };
                    preparaRiepilogoRicarica(riepilogoDaPendingPayment);
                    //preparaRiepilogoRicarica(pendingPayment);
                } else {
                    setSatispayPaymentDetails("Hai una ricarica pendente con id: "+datiRicaricaObj.satispayPaymentId+" completa il pagamento o richiedi una verifica, E78");
                }
            }
            else {
                if ( datiRicaricaObj.hasOwnProperty('satispayPayment') ) {
                    const datiRicarica_sp = datiRicaricaObj['satispayPayment'];
                    if ( datiRicarica_sp.hasOwnProperty('satispayResponseData') ) {
                        preparaRiepilogoRicarica(datiRicarica_sp['satispayResponseData']);
                    } else {
                        setSatispayPaymentDetails("Hai una ricarica pendente con id: "+datiRicaricaObj.satispayPaymentId+" completa il pagamento o richiedi una verifica, E104");
                    }
                } else {
                    setSatispayPaymentDetails("Hai una ricarica pendente con id: "+datiRicaricaObj.satispayPaymentId+" completa il pagamento o richiedi una verifica, E107");
                }
                //setSatispayPaymentDetails(datiRicarica);
            }
        } else {
            console.error("satispayPaymentDetails not found in localStorage");
        }
    }, []);

    const handleChiusuraLink = () => {
        console.log("Conclusione Ricarica");
        // genero l'href per il redirect
        window.location.href = "/app";
        return;
        // Logica per eseguire la ricarica con Satispay
        /*console.log(`Ricarica di ${amount} euro eseguita con successo!`);
        axios.post('/api/ricarica', { amount })
            .then(response => {
                console.log(response.data);
            })
            .catch(error => {
                console.error(error);
            });*/
    };

    const handleTornaRicaricaSatispay = () => {
        window.location.href = "/app/ricarica/satispay";
        return;
    };

    const handleTornaRicaricaForm = () => {
        window.location.href = "/app/ricarica";
        return;
    };

    //const oraPrenotaData = oraPrenotaStore.getState(); // è uno UserState
    //const datiContenutiInUserState = JSON.stringify(oraPrenotaData);
    //leggo dallo store UI i dati che in altra pagina ho salvato mediante uiStore.setSatispayPaymentDetails(datiRicarica);
    console.log('Dati ricarica: ', satispayPaymentDetails);

    const generaLink = (satispayPaymentId: string, satispaySandBoxMode: boolean) => {
        console.log("Genero link per redirect a partire da satispayPaymentId: ", satispayPaymentId, " e satispaySandBoxMode: ", satispaySandBoxMode);
        let urlDiRitorno = window.location.href +"?id="+satispayPaymentId;
        let hrefPerRedirect = "";
        if (typeof satispaySandBoxMode !== "boolean" && satispaySandBoxMode !== false) {
            hrefPerRedirect = `https://staging.online.satispay.com/pay/`;
        } else {
            hrefPerRedirect = `https://online.satispay.com/pay/`;
        }
        hrefPerRedirect += satispayPaymentId + "?redirect_url=" + encodeURIComponent(urlDiRitorno);
        return hrefPerRedirect;
    };

    interface Riepilogo {
        amount_unit: number;
        status: string;
        id: string;
        //scadenza: Date;
        [key: string]: any;
    }

    const preparaRiepilogoRicarica = (oggettoRiepilogo: Riepilogo) => {
        const importoRicarica = Math.floor( oggettoRiepilogo["amount_unit"] /100 );
        let stato = "SCONOSCIUTO";
        switch (oggettoRiepilogo.status) {
            case "PENDING": 
                stato = "IN ATTESA"; 
                setMessaggioUlteriore(SatispayMessaggi.PAGAMENTOPENDENTE);
                setBtnVaiARicarica(<Button id="vaiARicaricaSatispay" variant="contained" color="warning" onClick={handleTornaRicaricaSatispay}>
                    TORNA ALLA SCHERMATA DI RICARICA PER VERIFICARE
                  </Button>);
                break;
            case "COMPLETED": 
                stato = "COMPLETATO"; 
                setMessaggioUlteriore(SatispayMessaggi.PAGAMENTOCONFERMATO);
                break;
            case "EXPIRED": 
                stato = "TERMINI DI PAGAMENTO SCADUTI"; 
                setMessaggioUlteriore(SatispayMessaggi.PAGAMENTOSCADUTO);
                setBtnVaiARicarica(<Button id="vaiARicarica" variant="contained" color="warning" onClick={handleTornaRicaricaForm}>
                    NUOVA RICARICA
                  </Button>);
                break;
            case "CANCELED": 
                stato = "ANNULLATO";
                setMessaggioUlteriore(SatispayMessaggi.PAGAMENTOANNULLATO);
                break;
            case "REFUNDED": stato = "RIMBORSATO"; break;
            case "FAILED": stato = "FALLITO"; break;
            default: stato = "SCONOSCIUTO"; break;
        }
        const textRiepilogoRicarica = `Importo: ${importoRicarica} € | Id Ricarica Satispay: ${oggettoRiepilogo.id} | Stato: ${stato}`;
        setSatispayPaymentDetails(textRiepilogoRicarica);
        return true;
    };

    const switchStatusDiPagamento = (statusDiPagamento: string) => {
        let stato = "SCONOSCIUTO";
        switch (statusDiPagamento) {
            case "PENDING": 
                stato = "IN ATTESA"; 
                setMessaggioUlteriore(SatispayMessaggi.PAGAMENTOPENDENTE);
                setBtnVaiARicarica(<Button id="vaiARicaricaSatispay" variant="contained" color="warning" onClick={handleTornaRicaricaSatispay}>
                    TORNA ALLA SCHERMATA DI RICARICA PER VERIFICARE
                  </Button>);
                break;
            case "COMPLETED": 
                stato = "COMPLETATO"; 
                setMessaggioUlteriore(SatispayMessaggi.PAGAMENTOCONFERMATO);
                attendiQualcheSecondoETornaAllaHome();
                break;
                case "EXPIRED": 
                stato = "TERMINI DI PAGAMENTO SCADUTI"; 
                setMessaggioUlteriore(SatispayMessaggi.PAGAMENTOSCADUTO);
                setBtnVaiARicarica(<Button id="vaiARicarica" variant="contained" color="warning" onClick={handleTornaRicaricaForm}>
                    NUOVA RICARICA
                  </Button>);
                break;
            case "CANCELED": 
                stato = "ANNULLATO";
                setMessaggioUlteriore(SatispayMessaggi.PAGAMENTOANNULLATO);
                break;
            case "REFUNDED": stato = "RIMBORSATO"; break;
            case "FAILED": stato = "FALLITO"; break;
            default:
                break;
        }
        return stato;
    };

    const attendiQualcheSecondoETornaAllaHome = () => {
        const timer = setTimeout(() => {
            window.location.href = "/app/gestionePrenotazioni";
        }, 10000);
        return;
    };

    return (
        <div>
            <h1>Bentornato da Satispay</h1>
            <p></p>
            <p>Dati Ricarica: {satispayPaymentDetails}</p>
            <p>{messaggioUlteriore}</p>
            <Button variant="contained" color="primary" onClick={handleChiusuraLink}>
              TORNA ALLA HOME
            </Button>
            {btnVaiARicarica}
            {/*<Button id="vaiARicarica" variant="contained" color="warning" onClick={handleTornaRicarica}>
              TORNA ALLA SCHERMATA DI RICARICA PER VERIFICARE
            </Button>*/}
        </div>
    );
};
